export default function Compain() {
  return <h1>Compain</h1>;
}
